import React from 'react';
import ReactSVG from 'react-svg';

import './index.less';

/**
 * 使用SVG显示GIFTO的ICON
 * @param size
 * @param type 展示的形式
 * @param style
 * @constructor
 */
function GiftoIcon({ size = '0.625rem', type = 'normal', style = {} } = {}) {
    //  所有的图标配置
    const svgList = {
        normal: '//g.cdn.pengpengla.com/oauthgame/html5/20180329/logo_1.svg', //  紫色的北京
        pink: '//g.cdn.pengpengla.com/oauthgame/html5/20180411/logo_pink.svg' //  粉色的背景
    };

    type = svgList[type] ? type : 'normal';

    return (
        <ReactSVG className="gift-icon" style={{ width: size, height: size, ...style }} path={svgList[type]}/>
    );
}

export {
    GiftoIcon
};



// WEBPACK FOOTER //
// ./js/component/gifto-icon/index.js